import {
  composeConfigureCachedFetchStore,
  defaultPersistConfig
} from "@mochi/core";
import { reducers, sagas } from "./features/@redux";
import { setReducerManager } from "@mochi/misc";

export const {
  store,
  persister,
  reducersManager
} = composeConfigureCachedFetchStore({
  sagas,
  reducers,
  persistConfig: {
    ...defaultPersistConfig,
    whitelist: ['bookingConfirm']
  }
});

setReducerManager(reducersManager);
